import { useState, useEffect, useRef } from "react";

const UNI = [
  { id: 1, name: "Alexander College", country: "Canada", region: "CAN", city: "Vancouver, BC", c: [-123.12, 49.28], url: "https://www.alexandercollege.ca" },
  { id: 2, name: "Canada West University", country: "Canada", region: "CAN", city: "Vancouver, BC", c: [-124.0, 49.5], url: "https://www.ucanwest.ca" },
  { id: 3, name: "Conestoga College", country: "Canada", region: "CAN", city: "Kitchener, ON", c: [-80.49, 43.45], url: "https://www.conestogac.on.ca" },
  { id: 4, name: "Coquitlam University", country: "Canada", region: "CAN", city: "Coquitlam, BC", c: [-122.82, 49.27], url: "https://www.coquitlam.edu" },
  { id: 5, name: "Fairleigh Dickinson University", country: "Canada", region: "CAN", city: "Vancouver, BC", c: [-122.5, 49.1], url: "https://www.fdu.edu" },
  { id: 6, name: "Kwantlen Polytechnic University", country: "Canada", region: "CAN", city: "Surrey, BC", c: [-122.85, 49.19], url: "https://www.kpu.ca" },
  { id: 7, name: "Thompson Rivers University", country: "Canada", region: "CAN", city: "Kamloops, BC", c: [-120.35, 50.67], url: "https://www.tru.ca" },
  { id: 8, name: "Sault College", country: "Canada", region: "CAN", city: "Sault Ste. Marie, ON", c: [-84.33, 46.52], url: "https://www.saultcollege.ca" },
  { id: 9, name: "University of Niagara Falls", country: "Canada", region: "CAN", city: "Niagara Falls, ON", c: [-79.07, 43.10], url: "https://www.unfc.ca" },
  { id: 10, name: "College of The Canyons", country: "USA", region: "USA", city: "Santa Clarita, CA", c: [-118.57, 34.41], url: "https://www.canyons.edu" },
  { id: 11, name: "Concordia University Chicago", country: "USA", region: "USA", city: "Chicago, IL", c: [-87.63, 41.88], url: "https://www.cuchicago.edu" },
  { id: 12, name: "Florida International University", country: "USA", region: "USA", city: "Miami, FL", c: [-80.37, 25.76], url: "https://www.fiu.edu" },
  { id: 13, name: "Franklin College", country: "USA", region: "USA", city: "Franklin, IN", c: [-86.05, 39.48], url: "https://www.franklincollege.edu" },
  { id: 14, name: "Louisiana State University", country: "USA", region: "USA", city: "Baton Rouge, LA", c: [-91.18, 30.41], url: "https://www.lsu.edu" },
  { id: 15, name: "Lynn University", country: "USA", region: "USA", city: "Boca Raton, FL", c: [-80.10, 26.35], url: "https://www.lynn.edu" },
  { id: 16, name: "Millennia Atlantic University", country: "USA", region: "USA", city: "Doral, FL", c: [-80.55, 25.72], url: "https://www.maufl.edu" },
  { id: 17, name: "Rollins University", country: "USA", region: "USA", city: "Winter Park, FL", c: [-81.34, 28.60], url: "https://www.rollins.edu" },
  { id: 18, name: "Santa Monica College", country: "USA", region: "USA", city: "Santa Monica, CA", c: [-118.49, 34.02], url: "https://www.smc.edu" },
  { id: 19, name: "Schiller International University", country: "USA", region: "USA", city: "Tampa, FL", c: [-82.45, 27.95], url: "https://www.schiller.edu" },
  { id: 20, name: "Texas Southern University", country: "USA", region: "USA", city: "Houston, TX", c: [-95.37, 29.76], url: "https://www.tsu.edu" },
  { id: 21, name: "Tulane University", country: "USA", region: "USA", city: "New Orleans, LA", c: [-90.12, 29.94], url: "https://www.tulane.edu" },
  { id: 22, name: "University of Idaho", country: "USA", region: "USA", city: "Moscow, ID", c: [-116.99, 46.73], url: "https://www.uidaho.edu" },
  { id: 23, name: "University of Florida", country: "USA", region: "USA", city: "Gainesville, FL", c: [-82.33, 29.64], url: "https://www.ufl.edu" },
  { id: 24, name: "University of Mary Hardin-Baylor", country: "USA", region: "USA", city: "Belton, TX", c: [-97.46, 31.05], url: "https://www.umhb.edu" },
  { id: 25, name: "University of North Texas", country: "USA", region: "USA", city: "Denton, TX", c: [-97.13, 33.21], url: "https://www.unt.edu" },
  { id: 26, name: "Westcliff University", country: "USA", region: "USA", city: "Irvine, CA", c: [-117.82, 33.68], url: "https://www.westcliff.edu" },
  { id: 27, name: "Hotel Escuela EcoTur", country: "Spain", region: "EUR", city: "Spain", c: [-3.70, 40.30], url: "https://www.ecotur.es" },
  { id: 28, name: "UCAM Universidad Católica de Murcia", country: "Spain", region: "EUR", city: "Murcia", c: [-1.13, 37.98], url: "https://www.ucam.edu" },
  { id: 29, name: "Universidad Pontificia de Salamanca", country: "Spain", region: "EUR", city: "Salamanca", c: [-5.66, 40.96], url: "https://www.upsa.es" },
  { id: 30, name: "Berlin School of Business & Innovation", country: "Germany", region: "EUR", city: "Berlin", c: [13.40, 52.52], url: "https://www.berlinsbi.com" },
  { id: 31, name: "CBS International Business School", country: "Germany", region: "EUR", city: "Cologne", c: [6.96, 50.94], url: "https://www.cbs.de" },
  { id: 32, name: "EU Business School", country: "Germany", region: "EUR", city: "Munich", c: [11.58, 48.14], url: "https://www.euruni.edu" },
  { id: 33, name: "Macromedia University", country: "Germany", region: "EUR", city: "Munich", c: [11.78, 48.0], url: "https://www.macromedia-university.com" },
  { id: 34, name: "University of Europe", country: "Germany", region: "EUR", city: "Berlin", c: [13.60, 52.38], url: "https://www.ue-germany.com" },
  { id: 35, name: "BHMS Business & Hotel Management School", country: "Switzerland", region: "EUR", city: "Lucerne", c: [8.30, 47.05], url: "https://www.bhms.ch" },
  { id: 36, name: "Wittenborg University", country: "Netherlands", region: "EUR", city: "Apeldoorn", c: [5.97, 52.21], url: "https://www.wittenborg.eu" },
  { id: 37, name: "GBS Dubai", country: "UAE", region: "ASIA", city: "Dubai", c: [55.27, 25.20], url: "https://www.gbs.ac.ae" },
  { id: 38, name: "SP Jain School of Global Management", country: "UAE", region: "ASIA", city: "Dubai", c: [55.5, 25.05], url: "https://www.spjain.org" },
  { id: 39, name: "SP Jain School of Global Management", country: "Singapore", region: "ASIA", city: "Singapore", c: [103.82, 1.35], url: "https://www.spjain.org" },
  { id: 40, name: "Birmingham University", country: "England", region: "EUR", city: "Birmingham", c: [-1.89, 52.49], url: "https://www.birmingham.ac.uk" },
  { id: 41, name: "Griffith College", country: "Ireland", region: "EUR", city: "Dublin", c: [-6.26, 53.33], url: "https://www.griffith.ie" },
];

const COL = { CAN: "#2B2B6B", USA: "#E31E24", EUR: "#1a6fa8", ASIA: "#c47d00" };
const RLABEL = { CAN: "Canada", USA: "United States", EUR: "Europe", ASIA: "Asia & Middle East" };
const ACTIVE_ISO = new Set([124, 840, 724, 276, 756, 528, 784, 702, 826, 372]);
const ISO_REG = { 124: "CAN", 840: "USA", 724: "EUR", 276: "EUR", 756: "EUR", 528: "EUR", 784: "ASIA", 702: "ASIA", 826: "EUR", 372: "EUR" };

const FILTERS = [
  { key: "ALL", label: "All" },
  { key: "CAN", label: "Canada" },
  { key: "USA", label: "USA" },
  { key: "EUR", label: "Europe" },
  { key: "ASIA", label: "Asia / ME" },
];

function project(lon, lat) {
  const cx = 480, cy = 255, scale = 155;
  const lam = (lon * Math.PI) / 180;
  const phi = (lat * Math.PI) / 180;
  const x = cx + scale * lam * (Math.cos(phi / 3) || 1) * 0.9;
  const y = cy - scale * phi * 1.4;
  return [x, y];
}

function geoPath(geo) {
  const { type, coordinates } = geo.geometry;
  const ring = (pts) =>
    pts.map((p, i) => {
      const [x, y] = project(p[0], p[1]);
      return `${i ? "L" : "M"}${x.toFixed(1)},${y.toFixed(1)}`;
    }).join("") + "Z";
  const poly = (cs) => cs.map(ring).join(" ");
  if (type === "Polygon") return poly(coordinates);
  if (type === "MultiPolygon") return coordinates.map(poly).join(" ");
  return "";
}

function Panel({ uni, onClose }) {
  if (!uni) return null;
  const col = COL[uni.region];
  
  return (
    <div style={{
      width: 260, flexShrink: 0, background: "#fff",
      borderLeft: "0.5px solid #e2e8f0", overflowY: "auto",
      transition: "width .3s ease",
    }}>
      <div style={{ padding: 18 }}>
        <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 14 }}>
          <div style={{
            width: 36, height: 36, borderRadius: 10,
            background: col + "18", border: `1px solid ${col}33`,
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: 18, color: col,
          }}>🏫</div>
          <button onClick={onClose} style={{
            background: "none", border: "1px solid #e2e8f0",
            borderRadius: "50%", width: 24, height: 24, cursor: "pointer",
            fontSize: 12, color: "#6b7280", display: "flex", alignItems: "center", justifyContent: "center",
          }}>✕</button>
        </div>

        <p style={{ fontSize: 10, letterSpacing: ".12em", textTransform: "uppercase", fontWeight: 500, color: col, marginBottom: 4 }}>
          {uni.country}
        </p>
        <p style={{ fontSize: 15, fontWeight: 500, color: "#1a1a2e", lineHeight: 1.35, marginBottom: 4 }}>
          {uni.name}
        </p>
        <p style={{ fontSize: 12, color: "#6b7280", marginBottom: 10, display: "flex", alignItems: "center", gap: 4 }}>
          📍 {uni.city}
        </p>

        
        {uni.url && (
          <a 
            href={uni.url} 
            target="_blank" 
            rel="noopener noreferrer" 
            style={{ 
              fontSize: 12, 
              color: col, 
              textDecoration: "underline", 
              fontWeight: 500,
              display: "block", 
              marginBottom: 14 
            }}
          >
            Official website →
          </a>
        )}

        <span style={{
          display: "inline-block", fontSize: 11, padding: "2px 10px", borderRadius: 12,
          fontWeight: 500, background: col + "18", color: col, border: `1px solid ${col}33`,
        }}>
          {RLABEL[uni.region]}
        </span>
        
        <div style={{ height: "0.5px", background: "#e2e8f0", margin: "14px 0" }} />
        
        <p style={{ fontSize: 12, color: "#6b7280", lineHeight: 1.7 }}>
          Credit transfer agreement with American College. Contact our internationalization
          department for details on specific benefits.
        </p>
      </div>
    </div>
  );
}

export default function PartnerUniversitiesMap() {
  const [features, setFeatures] = useState([]);
  const [activeFilter, setActiveFilter] = useState("ALL");
  const [searchQ, setSearchQ] = useState("");
  const [selectedUni, setSelectedUni] = useState(null);
  const [hoveredPin, setHoveredPin] = useState(null);

  useEffect(() => {
    fetch("https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json")
      .then((r) => r.json())
      .then((world) => {
        // requires topojson-client installed: npm install topojson-client
        import("topojson-client").then(({ feature }) => {
          setFeatures(feature(world, world.objects.countries).features);
        });
      });
  }, []);

  const pinVisible = (u) => {
    if (activeFilter !== "ALL" && u.region !== activeFilter) return false;
    const q = searchQ.toLowerCase();
    if (q && !u.name.toLowerCase().includes(q) && !u.city.toLowerCase().includes(q) && !u.country.toLowerCase().includes(q)) return false;
    return true;
  };

  return (
    <div style={{ fontFamily: "system-ui, sans-serif", border: "0.5px solid #e2e8f0", borderRadius: 12, overflow: "hidden", background: "#f5f7fb" }}>
      {/* Top bar */}
      <div style={{
        background: "#fff", padding: "14px 18px",
        display: "flex", alignItems: "center", justifyContent: "space-between",
        flexWrap: "wrap", gap: 10, borderBottom: "0.5px solid #e2e8f0",
      }}>
        <div>
          <div style={{ fontSize: 15, fontWeight: 500, color: "#2B2B6B" }}>Partner universities</div>
          <div style={{ fontSize: 11, color: "#6b7280" }}>International credit transfer network</div>
        </div>
        <div style={{ display: "flex", gap: 18 }}>
          {[["41", "Universities"], ["11", "Countries"], ["4", "Regions"]].map(([n, l]) => (
            <div key={l} style={{ textAlign: "center" }}>
              <div style={{ fontSize: 18, fontWeight: 500, color: "#E31E24", lineHeight: 1 }}>{n}</div>
              <div style={{ fontSize: 10, color: "#6b7280", textTransform: "uppercase", letterSpacing: ".08em" }}>{l}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Filter bar */}
      <div style={{
        background: "#fff", padding: "10px 18px",
        display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap",
        borderBottom: "0.5px solid #e2e8f0",
      }}>
        {FILTERS.map(({ key, label }) => {
          const isOn = activeFilter === key;
          const col = key === "ALL" ? "#2B2B6B" : COL[key];
          return (
            <button
              key={key}
              onClick={() => setActiveFilter(key)}
              style={{
                padding: "5px 12px", borderRadius: 20, fontSize: 12,
                cursor: "pointer", fontFamily: "inherit",
                border: `1px solid ${isOn ? "transparent" : "#e2e8f0"}`,
                background: isOn ? col : "transparent",
                color: isOn ? "#fff" : "#6b7280",
                display: "flex", alignItems: "center", gap: 5,
                transition: "all .15s",
              }}
            >
              {key !== "ALL" && (
                <span style={{ width: 7, height: 7, borderRadius: "50%", background: isOn ? "#fff" : COL[key], flexShrink: 0 }} />
              )}
              {label}
            </button>
          );
        })}
        <div style={{
          marginLeft: "auto", display: "flex", alignItems: "center", gap: 6,
          border: "1px solid #e2e8f0", borderRadius: 20, padding: "5px 12px", background: "#fff",
        }}>
          <span style={{ fontSize: 14, color: "#6b7280" }}>🔍</span>
          <input
            type="text"
            placeholder="Search…"
            value={searchQ}
            onChange={(e) => setSearchQ(e.target.value)}
            style={{ border: "none", outline: "none", fontSize: 12, background: "transparent", color: "#1a1a2e", width: 140 }}
          />
        </div>
      </div>

      {/* Map + panel */}
      <div style={{ display: "flex", minHeight: 400 }}>
        <div style={{ flex: 1, background: "#dce6f0", position: "relative", overflow: "hidden" }}>
          <svg viewBox="0 0 960 480" style={{ display: "block", width: "100%", height: "auto" }}>
            <rect width={960} height={480} fill="#dce6f0" />

            {/* Country fills */}
            <g>
              {features.map((geo) => {
                const iso = parseInt(geo.id);
                const d = geoPath(geo);
                if (!d) return null;
                const isActive = ACTIVE_ISO.has(iso);
                const reg = ISO_REG[iso];
                const dimmed = activeFilter !== "ALL" && reg && reg !== activeFilter;
                return (
                  <path
                    key={geo.id}
                    d={d}
                    fill={isActive ? (dimmed ? "#cdd6e0" : "#b8ccdf") : "#c2cedc"}
                    stroke="#b0bed0"
                    strokeWidth="0.5"
                  />
                );
              })}
            </g>

            {/* Pins */}
            <g>
              {UNI.map((u) => {
                const [x, y] = project(u.c[0], u.c[1]);
                if (x < 0 || x > 960 || y < 0 || y > 480) return null;
                const col = COL[u.region];
                const vis = pinVisible(u);
                const isSelected = selectedUni?.id === u.id;
                const isHov = hoveredPin === u.id;
                const big = isSelected || isHov;
                return (
                  <g
                    key={u.id}
                    style={{ cursor: "pointer", opacity: vis ? 1 : 0.12, transition: "opacity .2s" }}
                    onClick={() => setSelectedUni(u)}
                    onMouseEnter={() => setHoveredPin(u.id)}
                    onMouseLeave={() => setHoveredPin(null)}
                  >
                    <circle cx={x} cy={y} r={big ? 14 : 9} fill={col} opacity={big ? 0.25 : 0.15} />
                    <circle cx={x} cy={y} r={big ? 6 : 4} fill={col} stroke="#fff" strokeWidth={big ? 2 : 1.5} />
                  </g>
                );
              })}
            </g>
          </svg>

          {!selectedUni && (
            <div style={{
              position: "absolute", bottom: 10, left: "50%", transform: "translateX(-50%)",
              fontSize: 11, color: "#6b7280", background: "#fff",
              padding: "4px 12px", borderRadius: 20, border: "0.5px solid #e2e8f0",
              whiteSpace: "nowrap", pointerEvents: "none",
            }}>
              Click a pin to explore
            </div>
          )}
        </div>

        {selectedUni && <Panel uni={selectedUni} onClose={() => setSelectedUni(null)} />}
      </div>
    </div>
  );
}